const workItemEnum = Object.freeze({
  MARKER_NAME: 'Marker Name',
  MAX_TEMPERATURE: 'Max Temperature',
  DELTA_T: 'Delta T',
  REFERENCE: 'Reference',
  MARKER_INFO: 'MARKER INFO',
  IMAGE_INFO: 'IMAGE INFO',
  THERMAL_IMAGE: 'THERMAL IMAGE',
  VISIBLE_LIGHT_IMAGE: 'VISIBLE LIGHT IMAGE',
  PHOTO_NOTES: 'PHOTO NOTES',
  LESS: 'Less',
  MORE: 'More',
});

export default workItemEnum;
